export default __webpack_public_path__ + "static/media/0cc7e6fc494609a1266d454e926c6fb81581611844603.3c8ff8fd.webp";